import { useViewerDecks, useViewerQuery } from "queries/viewerQuery";
import { langs } from "../../sharedJs__generated/langsList";
import { Howler } from "howler";
import { getApiOrigin } from "tools/env";
import CryptoJS from "crypto-js";

// https://stackoverflow.com/a/34842797/844628
export const hashCode = (s: string, voiceId?: string) => {
  const md5 = CryptoJS.MD5(s).toString();
  return `h${md5}${voiceId || ""}`;
};

export const canTts = (lang?: string) => !!lang && !!langs[lang] && langs[lang].tts !== false;
export const canMultiLangTts = (languages: string[]) =>
  !!languages?.length && languages.length > 0 && languages.every((l) => langs[l]?.multiLangTts);

export const silenceTts = () => {
  Howler.stop();
};

/**
 * Returns array of voices which starts by next voice after lastVoices
 */
export const usePickVoices = (lang?: string, lastVoice?: string) => {
  const { decks } = useViewerDecks();
  const { viewer } = useViewerQuery();

  let voices = decks?.find((d) => d.front === lang)?.voices?.map((v) => v.id);
  if (!voices || !viewer?.subscription) {
    return undefined;
  }
  const lastVoiceInd = voices?.findIndex((v) => v === lastVoice);
  if (!lastVoice || lastVoiceInd === -1 || lastVoiceInd === voices.length - 1) {
    return voices;
  }
  const rotateByElements = lastVoiceInd + 1;
  return voices.concat(voices.splice(0, rotateByElements)); // src: https://stackoverflow.com/a/1521121/844628
};

export const createTtsStreamUrl = (
  text: string,
  params: {
    token?: string;
    speakingRate?: number;
  }
): string => {
  const { token, speakingRate = 1.0 } = params;
  const baseUrl = getApiOrigin();
  const queryParams = new URLSearchParams();
  queryParams.append("text", text);
  queryParams.append("token", token || "");
  if (speakingRate !== undefined) queryParams.append("speakingRate", speakingRate.toString());
  return `${baseUrl}/tts-stream?${queryParams.toString()}`;
};
